import gql from "graphql-tag";

export const INVITE_CLIENT = gql`
  mutation inviteClient($input: inviteClientInput) {
    inviteClient(input: $input) {
      email
    }
  }
`;
